const TOKEN_KEY = 'admin_token'

/**
 * 存储token到本地
 * @param {string} token - 后端返回的token
 */
export function setToken(token) {
  // 建议用localStorage（持久化，刷新页面不丢失）
  // 若用sessionStorage，关闭页面后会丢失
  localStorage.setItem(TOKEN_KEY, token)
}

/**
 * 从本地获取token
 * @returns {string|null} - 返回token或null
 */
export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || null
}

/**
 * 清除本地token（退出登录时用）
 */
export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}

// 检查是否有Token
export function hasToken() {
  return !!getToken()
}

// 获取用户身份
export function getRole() {
  return localStorage.getItem('roles')
}
